// src/pages/EmploiDuTemps.jsx
import React, { useEffect, useState } from "react";
import { useUserContext } from "../../contexts/UserContext";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from 'react-router-dom';

const days = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi"];
// const hours = [
//   "08:00","09:00","10:00","11:00","12:00",
//   "13:00","14:00","15:00","16:00","17:00"
// ];

const AdminSidebar = () => {
  const navigate = useNavigate();
  const items = [
    { name: "Dashboard", path: "/AdminDashboard" },
    { name: "Professeurs", path: "/TeachersPage" },
    { name: "Classes", path: "/classes" },
    { name: "Cours", path: "/courses" },
    { name: "Etudiant", path: "/student" },
    { name: "Examens", path: "/exams" },
    { name: "Salles", path: "/rooms" },
    { name: "bulletins", path: "/bulletins" },
    { name: "Notifications", path: "/notifications" },
    { name: "Gestion Utilisateurs", path: "/administrator" },
    { name: "Profil", path: "/profile" },
    { name: "Déconnexion", path: "/logout" },
  ];

  return (
    <div style={sidebarStyle}>
      <h2 style={{ marginBottom: "30px" }}>Menu</h2>
      {items.map((item, idx) => (
        <div key={idx} style={sidebarItemStyle} onClick={() => navigate(item.path)}>
          {item.name}
        </div>
      ))}
    </div>
  );
};

export default function EmploiDuTemps() {
  const { getAuthHeaders } = useUserContext();
  const [schedules, setSchedules] = useState([]);
  const [selectedCell, setSelectedCell] = useState(null);
const [formData, setFormData] = useState({
  course: "",
  teacher: "",
  class: "",
  location: "",
});
const [hours, setHours] = useState([
  "08:00","09:00","10:00","11:00","12:00",
  "13:00","14:00","15:00","16:00","17:00"
]);
const [newHour, setNewHour] = useState("");

  const [courses, setCourses] = useState([]);
const [teachers, setTeachers] = useState([]);
const [classes, setClasses] = useState([]);
const [selectedClass, setSelectedClass] = useState("");


const getCourseColor = (courseName) => {
  const colors = {
    Math: "#3b82f6",
    Français: "#ef4444",
    Histoire: "#10b981",
    Physique: "#8b5cf6",
    Anglais: "#f59e0b",
  };

  return colors[courseName] || "#64748b";
};

const fetchData = async () => {
  try {
    const [c, t, cl] = await Promise.all([
      fetch("/api/courses", { headers: getAuthHeaders() }),
      fetch("/api/teachers", { headers: getAuthHeaders() }),
      fetch("/api/classes", { headers: getAuthHeaders() }),
    ]);

    setCourses(await c.json());
    setTeachers(await t.json());
    setClasses(await cl.json());
  } catch {
    toast.error("Erreur chargement données");
  }
};

  // 🔹 Fetch
  const fetchSchedules = async () => {
    try {
      const res = await fetch("/api/schedules", {
        headers: getAuthHeaders(),
      });
      const data = await res.json();
      setSchedules(data);
    } catch {
      toast.error("Erreur chargement emploi du temps");
    }
  };

useEffect(() => {
  fetchSchedules();
  fetchData();
}, []);

  // 🔹 Save (create)
  const handleSave = async () => {
    try {
      await fetch("/api/schedules", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...getAuthHeaders(),
        },
        body: JSON.stringify({
          ...formData,
          day: selectedCell.day,
          startTime: selectedCell.hour,
          endTime: selectedCell.hour,
        }),
      });

      toast.success("Créneau ajouté");
      setSelectedCell(null);
      setFormData({ course: "", teacher: "", location: "" });
      fetchSchedules();
    } catch {
      toast.error("Erreur ajout");
    }
  };

const getCellData = (day, hour) => {
  return schedules.filter(
    (s) =>
      s.day === day &&
      s.startTime === hour &&
      (!selectedClass || s.class?._id === selectedClass)
  );
};


  return (
    <div className="layout">
      <AdminSidebar />
      <div className="content">
        <Toaster />

        <h1 className="title">📅 Emploi du temps</h1>

        <select
  className="filter"
  value={selectedClass}
  onChange={(e) => setSelectedClass(e.target.value)}
>
  <option value="">Toutes les classes</option>
  {classes.map((c) => (
    <option key={c._id} value={c._id}>
      {c.name}
    </option>
  ))}
</select>

<div style={{ marginBottom: "20px" }}>
  <h3>Gestion des horaires</h3>
  <input
    type="time"
    onChange={(e) => setNewHour(e.target.value)}
    value={newHour || ""}
  />
  <button onClick={() => {
    if (newHour && !hours.includes(newHour)) {
      setHours([...hours, newHour].sort());
      setNewHour("");
    }
  }}>Ajouter</button>
</div>

        <div className="grid-container">
          <table className="schedule-table">
            <thead>
              <tr>
                <th>Heures</th>
                {days.map((d) => (
                  <th key={d}>{d}</th>
                ))}
              </tr>
            </thead>

            <tbody>
              {hours.map((hour) => (
                <tr key={hour}>
                  <td className="hour">{hour}</td>

                  {days.map((day) => {
                    const data = getCellData(day, hour);

                    return (
                      <td key={day}
                        className="cell"
                        onClick={() => setSelectedCell({ day, hour })}>
                 {data.length > 0 ? (
                            data.map((event, i) => (
                                <div
                                key={i}
                                className="event"
                                style={{ background: getCourseColor(event.course?.title) }}
                                >
                                <strong>{event.course?.title}</strong>
                                <span>{event.teacher?.name}</span>
                                <small>{event.location}</small>
                                </div>
                            ))
                            ) : (
                            <span className="empty">+</span>
                            )}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* MODAL */}
        {selectedCell && (
          <div className="modal-overlay">
            <div className="modal">
              <h2>
                Ajouter - {selectedCell.day} ({selectedCell.hour})
              </h2>

              

             <select
  value={formData.course}
  onChange={(e) => setFormData({ ...formData, course: e.target.value })}
>
  <option value="">Choisir un cours</option>
  {courses.map((c) => (
    <option key={c._id} value={c._id}>
      {c.title}
    </option>
  ))}
</select>

<select
  value={formData.teacher}
  onChange={(e) => setFormData({ ...formData, teacher: e.target.value })}
>
  <option value="">Choisir un prof</option>
  {teachers.map((t) => (
    <option key={t._id} value={t._id}>
      {t.name}
    </option>
  ))}
</select>

<select
  value={formData.class}
  onChange={(e) => setFormData({ ...formData, class: e.target.value })}
>
  <option value="">Choisir une classe</option>
  {classes.map((c) => (
    <option key={c._id} value={c._id}>
      {c.name}
    </option>
  ))}
</select>
<input
  type="time"
  value={formData.endTime || ""}
  onChange={(e) => setFormData({ ...formData, endTime: e.target.value })}
/>

              <div className="modal-actions">
                <button onClick={() => setSelectedCell(null)}>Annuler</button>
                <button onClick={handleSave} className="primary">
                  Enregistrer
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* 🔥 CSS SaaS */}
      <style jsx="true">{`
        .layout {
          display: flex;
          background: #f1f5f9;
          min-height: 100vh;
        }

        .content {
          flex: 1;
          padding: 30px;
        }

        .title {
          font-size: 24px;
          font-weight: bold;
          margin-bottom: 20px;
        }

        .grid-container {
          background: white;
          padding: 20px;
          border-radius: 12px;
          box-shadow: 0 5px 15px rgba(0,0,0,0.05);
          overflow-x: auto;
        }

        .schedule-table {
          width: 100%;
          border-collapse: collapse;
        }

        .schedule-table th {
          background: #0f172a;
          color: white;
          padding: 12px;
          text-align: center;
        }

        .schedule-table td {
          border: 1px solid #e2e8f0;
          height: 80px;
          text-align: center;
          cursor: pointer;
          position: relative;
        }

        .hour {
          background: #f8fafc;
          font-weight: bold;
        }

        .cell:hover {
          background: #f1f5f9;
        }

        .event {
          background: #3b82f6;
          color: white;
          padding: 6px;
          border-radius: 6px;
          font-size: 12px;
        }

        .empty {
          color: #94a3b8;
          font-size: 20px;
        }

        /* MODAL */
        .modal-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.5);
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .modal {
          background: white;
          padding: 25px;
          border-radius: 10px;
          width: 350px;
          display: flex;
          flex-direction: column;
          gap: 10px;
        }

        .modal input {
          padding: 10px;
          border: 1px solid #ddd;
          border-radius: 6px;
        }

        .modal-actions {
          display: flex;
          justify-content: flex-end;
          gap: 10px;
          margin-top: 10px;
        }

        .modal-actions button {
          padding: 8px 14px;
          border-radius: 6px;
          border: none;
          cursor: pointer;
        }

        .primary {
          background: #3b82f6;
          color: white;
        }
      `}</style>
      
    </div>
  );
}
const sidebarStyle = { width: "220px", background: "#0f172a", color: "#fff", padding: "20px" };
const sidebarItemStyle = {
  padding: "12px",
  marginBottom: "10px",
  borderRadius: "8px",
  cursor: "pointer",
  background: "#1e3a8a",
};